import { render, staticRenderFns } from "./BrandModuleDetail.vue?vue&type=template&id=72e067b1&scoped=true&"
import script from "./BrandModuleDetail.vue?vue&type=script&lang=js&"
export * from "./BrandModuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./BrandModuleDetail.vue?vue&type=style&index=0&id=72e067b1&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e067b1",
  null
  
)

export default component.exports